import React, { Component, useState, useEffect} from 'react';
import { array, string, func } from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import classNames from 'classnames';
import { lazyLoadWithDimensions } from '../../util/contextHelpers';
import { LINE_ITEM_DAY, LINE_ITEM_NIGHT, propTypes } from '../../util/types';
import { formatMoney } from '../../util/currency';
import { ensureListing } from '../../util/data';
import { richText } from '../../util/richText';
import { findOptionsForSelectFilter } from '../../util/search';
import { createSlug } from '../../util/urlHelpers';
import config from '../../config';
import { NamedLink, ResponsiveImage } from '../../components';
import { types as sdkTypes } from '../../util/sdkLoader';

import css from './ListingCard.module.css';
const sharetribeSdk = require('sharetribe-flex-sdk');


const sdk = sharetribeSdk.createInstance({
    clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID
  });
  const sdkUtil = sharetribeSdk.util;

const { UUID, LatLng } = sdkTypes;

const MIN_LENGTH_FOR_LONG_WORDS = 10;

const priceData = (price, intl) => {
  if (price && price.currency === config.currency) {
    const formattedPrice = formatMoney(intl, price);
    return { formattedPrice, priceTitle: formattedPrice };
  } else if (price) {
    return {
      formattedPrice: intl.formatMessage(
        { id: 'ListingCard.unsupportedPrice' },
        { currency: price.currency }
      ),
      priceTitle: intl.formatMessage(
        { id: 'ListingCard.unsupportedPriceTitle' },
        { currency: price.currency }
      ),
    };
  }
  return {};
};

const getserviceInfo = (serviceOptions, key) => {
  return serviceOptions.find(c => c.key === key);
};

class ListingImage extends Component {
  render() {
    return <ResponsiveImage {...this.props} />;
  }
}
const LazyImage = lazyLoadWithDimensions(ListingImage, { loadAfterInitialRendering: 3000 });

export const ListingCardComponent = props => {
  const {
    className,
    rootClassName,
    intl,
    listing,
    renderSizes,
    filtersConfig,
    setActiveListing,
  } = props;

  const [reviewsNumber, setReviewsNumber] = useState(0);
  const [userImage, setUserImage] = useState(null);

  useEffect(() => {

    sdk.listings.show({id: new UUID(listing.id.uuid)}).then(res => {
      const publicData = res.data.data.attributes.publicData;
      const consultationID = publicData.consultationId;
      const brainstormID = publicData.brainstormId;
      const mockID = publicData.mockId;
      const personalStatementEditingID = publicData.personalStatementEditingId;
      const secondaryStatementEditingID = publicData.secondaryStatementEditingId;


      return sdk.reviews.query({
        listingId: new UUID(consultationID)
      }).then(resp => {
          const consultationReviewsNr = resp.data.data.length;
       
                return sdk.reviews.query({
                  listingId: new UUID(brainstormID)
                }).then(resp => {
                  const brainstormReviewsNr = resp.data.data.length;

                          return sdk.reviews.query({
                            listingId: new UUID(mockID)
                          }).then(resp => {
                            const mockReviewsNr = resp.data.data.length;

                                        return sdk.reviews.query({
                                          listingId: new UUID(personalStatementEditingID)
                                        }).then(resp => {
                                          const personalStatementEditingReviewsNr = resp.data.data.length;

                                                      return sdk.reviews.query({
                                                        listingId: new UUID(secondaryStatementEditingID)
                                                      }).then(resp => {
                                                        const secondaryStatementEditingReviewsNr = resp.data.data.length;

               setReviewsNumber(consultationReviewsNr + brainstormReviewsNr + mockReviewsNr + personalStatementEditingReviewsNr + secondaryStatementEditingReviewsNr)                                          
              return sdk.users.show({
                id: new UUID(listing.author.id.uuid),
                include: "profileImage",
              }).then(res => {
  
                const imageId = res.data.data.relationships.profileImage.data.id;
                const imageLink = res.data.data.attributes.profile.publicData.profileImageLink;
  
                const imageObj =  {
                  "id": imageId,
                  "type": "image",
                  "attributes": {
                      "variants": {
                          "landscape-crop": {
                              "height": 267,
                              "width": 400,
                              "url": imageLink,
                              "name": "landscape-crop"
                          },
                          "landscape-crop2x": {
                              "height": 533,
                              "width": 800,
                              "url": imageLink,
                              "name": "landscape-crop2x"
                          }
                      }
                  }
              }
  
              setUserImage(imageObj)
  
              }).catch(error => console.log(error));
  

    }).catch(error => console.log(error));

  
}).catch(error => console.log(error));

}).catch(error => console.log(error));
}).catch(error => console.log(error));
}).catch(error => console.log(error));
}).catch(error => console.log(error));
  }
, []);



 
  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureListing(listing);
  const id = currentListing.id.uuid;
  const { title = '', price, publicData } = currentListing.attributes;
  const slug = createSlug(title);
  const firstImage = userImage ? userImage : null;

  const serviceOptions = findOptionsForSelectFilter('service', filtersConfig);
  const service = publicData
    ? getserviceInfo(serviceOptions, publicData.service)
    : null;
  const { formattedPrice, priceTitle } = priceData(price, intl);

  const unitType = config.bookingUnitType;
  const isNightly = unitType === LINE_ITEM_NIGHT;
  const isDaily = unitType === LINE_ITEM_DAY;

  const unitTranslationKey = isNightly
    ? 'ListingCard.perNight'
    : isDaily
    ? 'ListingCard.perDay'
    : 'ListingCard.perUnit';
 

  const allPricesArray = [currentListing.attributes.publicData.brainstormPrice ? parseFloat(currentListing.attributes.publicData.brainstormPrice) : 999999,
    currentListing.attributes.publicData.consultationPrice ? parseFloat(currentListing.attributes.publicData.consultationPrice) : 999999,
    currentListing.attributes.publicData.mockPrice ? parseFloat(currentListing.attributes.publicData.mockPrice) : 999999,
    currentListing.attributes.publicData.personalStatementEditingPrice ? parseFloat(currentListing.attributes.publicData.personalStatementEditingPrice) : 999999,
    currentListing.attributes.publicData.secondaryStatementEditingPrice ? parseFloat(currentListing.attributes.publicData.secondaryStatementEditingPrice) : 999999
  ]

  const getMinimumPrice = (array) => {
    return Math.min.apply( Math, array );
  }

  const pricesArray = [...allPricesArray].filter(price => {
    return price > 0
  })
  const minimumPriceTemporary = getMinimumPrice(pricesArray)

  console.log(currentListing.attributes)
  
  // TODO Remove the upper code after final deploy
  // const minimumPrice = currentListing.attributes.price !== null ? currentListing.attributes.price.amount/100 : minimumPriceTemporary;
  const minimumPrice = minimumPriceTemporary;

  const school = currentListing.attributes.publicData.school ? currentListing.attributes.publicData.school.School : null;
  const acceptedSchools = currentListing.attributes.publicData.acceptedAtSchoolsForSearch ? currentListing.attributes.publicData.acceptedAtSchoolsForSearch : [];
  const undergrad = currentListing.attributes.publicData.undergrad ? currentListing.attributes.publicData.undergrad : null;
  const listingPublicData = currentListing.attributes.publicData;
  const listingServicesArray = listingPublicData.services ? listingPublicData.services : []; 
 
  const allServicesArray = [
    listingServicesArray.find(service => { return service === "mock" }) === "mock" ? "Mock interview" : null,
    listingServicesArray.find(service => { return service === "brainstorm" }) === "brainstorm" ? "Personal statement brainstorm" : null,
    listingServicesArray.find(service => { return service === "consultation" }) === "consultation" ? "Consultation" : null,
    listingServicesArray.find(service => { return service === "personal" }) === "personal" ? "Personal statement editing" : null,
    listingServicesArray.find(service => { return service === "secondary" }) === "secondary" ? "Secondary statement editing" : null,
  ];
  const availableServicesArray = allServicesArray.filter(label => {
    return label !== null
  })

  const greekLife = currentListing.attributes.publicData.greekLife === "yes" ? "Greek life" : null;
  const major = currentListing.attributes.publicData.major;

  const extraInfoArray = [greekLife, major];
  const filteredExtraInfoArray = extraInfoArray.filter(info => {
    return(
      info !== null
    )
  })

  const hometown = currentListing.attributes.publicData.hometown;

  return (
    <div className={css.listingWrapper}>
    <NamedLink className={classes} name="ListingPage" params={{ id, slug }}>
      <div
        className={css.threeToTwoWrapper}
        onMouseEnter={() => setActiveListing(currentListing.id)}
        onMouseLeave={() => setActiveListing(null)}
      >
        <div className={css.aspectWrapper}>
          <LazyImage
            rootClassName={css.rootForImage}
            alt={title}
            image={firstImage}
            variants={['landscape-crop', 'landscape-crop2x']}
            sizes={renderSizes}
          />
        </div>
      </div>
      
    </NamedLink>
    <NamedLink className={css.mainInfo} name="ListingPage" params={{ id, slug }}>
    <div className={css.mainInfo}>

          <div className={css.title}>
            <div>
            {/* {richText(title, {
              longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
              longWordClass: css.longWord,
            })} */}
            <span className={school ? css.school : css.noSchool}>{`Helper at ${school}`}</span>
            </div>
            <div className={css.info}>
            {/* <span className={css.reviews}>{reviewsNumber === 1 ? `${reviewsNumber} review` : `${reviewsNumber} reviews`}</span>

                <div className={css.price}>
                  <div className={css.priceValue} title={priceTitle}>
                    {`From $${minimumPrice}`}
                  </div>
                </div> */}
            </div>
          </div>

          <div className={css.alsoAcceptedSchoolsDiv}>
            <i><span>{`Also accepted to: `}</span>{acceptedSchools.map(school => {
              return(
                <span>{`${school}, `}</span>
              )
            })}</i>
          </div>

          <div className={css.undergradDiv}>
            <span>{`Major: ${major}`}</span>
          </div>

          <div className={css.undergradDiv}>
            <span>{`Undergrad: ${undergrad}`}</span>
          </div>

         

          <div className={css.listingDescription}>
              <span>{currentListing.attributes.description}</span>
          </div>

          {/* <div className={css.otherInfo}>
              {filteredExtraInfoArray.map(info => {
                return(
                    <span className={css.extraInfoLabel}>{info}</span>
                )
              })}
          </div> */}

          <div className={css.serviceInfo}>
            {availableServicesArray.map(service => {
              return(
                <span className={css.extraInfoLabel}>{service}</span>
              )
            })}
          </div>
          
        </div>
        </NamedLink>
    </div>
  );
};

ListingCardComponent.defaultProps = {
  className: null,
  rootClassName: null,
  renderSizes: null,
  filtersConfig: config.custom.filters,
  setActiveListing: () => null,
};

ListingCardComponent.propTypes = {
  className: string,
  rootClassName: string,
  filtersConfig: array,
  intl: intlShape.isRequired,
  listing: propTypes.listing.isRequired,

  // Responsive image sizes hint
  renderSizes: string,

  setActiveListing: func,
};

export default injectIntl(ListingCardComponent);
